import React, { createContext, useEffect, useState, useContext } from 'react';
import { formatUsername } from '../utilities/formatUsername';

const USER_STATE_LOGGED_IN = `USER_STATE_LOGGED_IN`;
const USER_STATE_NOT_LOGGED_IN = `USER_STATE_NOT_LOGGED_IN`;
const USER_STATE_PENDING = `USER_STATE_PENDING`;

const UserSessionContext = createContext({
  data: null,
  setUser: () => {},
});

const UserSessionProvider = (props) => {
  const [user, setUser] = useState({ state: USER_STATE_PENDING });

  const genUserFromData = (data) => {
    if (!data) {
      return null;
    }

    user.isMember = true;
    user.email = data.mail;
    user.username = data.name;
    user.hashedUserId = data.uuid;
    user.picture = data.picture?.url;
    user.name = formatUsername(data);
    user.memberFor = new Date() - parseInt(data.created);
    return user;
  };

  const getUser = async () => {
    // Read it from user_store if we're accessing GE from a Drupal link
    const userId = localStorage.getItem('userId') || getUserIdFromUserStore();
    if (!userId) {
      throw new Error(`Something went wrong in user API`);
    }

    const [userPromise, allGenomesPromise] = await Promise.allSettled([
      fetch(`/api/sequencing/public/user/${userId}`),
      fetch(`/api/v1/genomes`),
    ]);

    let userData = {};
    let allGenomesData = {};

    if (userPromise.status === 'fulfilled' && userPromise.value.ok) {
      userData = await userPromise.value.json();
      if (!userData.error) {
        userData = genUserFromData({ ...userData });
      }
    }

    if (allGenomesPromise.status === 'fulfilled' && allGenomesPromise.value.ok) {
      allGenomesData = await allGenomesPromise.value.json();
      if (!allGenomesData.error) {
        allGenomesData = allGenomesData.tabs;
      }
    }

    return {
      ...userData,
      allGenomesData,
    };
  };

  const getUserIdFromUserStore = () => {
    const userId = JSON.parse(localStorage.getItem('user_store'))?.state?.user
      .uid;
    if (userId) localStorage.setItem('userId', userId);

    return userId;
  };

  useEffect(() => {
    getUser()
      .then((data) => {
        if (data.error) {
          setUser({
            state: USER_STATE_NOT_LOGGED_IN,
            referrer: document.referrer,
          });
          window.dataLayer?.push({ event: `start_pw` });
        } else {
          setUser({
            ...data,
            state: USER_STATE_LOGGED_IN,
          });
          window.dataLayer?.push({
            event: `start_pw`,
            pw_user_email: data.email,
          });
        }
      })
      .catch((err) => {
        setUser({
          state: USER_STATE_NOT_LOGGED_IN,
          referrer: document.referrer,
        });
        window.dataLayer?.push({ event: `start_pw` });
      });
  }, []);

  return (
    <UserSessionContext.Provider
      value={{
        data: user,
        setUser: (data) => setUser(genUserFromData(data)),
      }}
    >
      {props.children}
    </UserSessionContext.Provider>
  );
};

export {
  UserSessionContext,
  UserSessionProvider,
  USER_STATE_PENDING,
  USER_STATE_LOGGED_IN,
  USER_STATE_NOT_LOGGED_IN,
};
